import Swiper, { Autoplay, Lazy, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-hero-banner-carousel]',
};

const classes = {
  swiperPagination: '.swiper-pagination',
};

class HeroBannerCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

      this.init();
    });
  }

  init() {
    // Init the carousel on load.
    this.initCarousels();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Autoplay, Lazy, Pagination],
      lazy: true,
      loop: true,
      freeMode: true,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: classes.swiperPagination,
        clickable: true,
      },
    });
  }
}

customElements.define('hero-banner-carousel', HeroBannerCarousel);
